<template>
  <div class="club_page">
    <!-- <div class="sub-header pad5t pad5b">
            <h2>تاریخچه امتیازات</h2>
        </div> -->
    <ClubHeader>
      <template v-slot:club-header-title>
        <h2 class="mar10t">تاریخچه امتیازات</h2>
      </template>
    </ClubHeader>
    <div class="club-box">
      <div class="custom-box">
        <h2 class="textCenter mar5b">
          امتیاز شما:<span class="primary-color mar5r">{{
          infoItems.score | persian
          }}</span>
        </h2>
        <img src="../../assets/img/diamond.png" alt="score-diamond" class="dBlock marAuto" />
      </div>
      <ClubFooter></ClubFooter>
      <div class="pad0">
        <h3 class="mar10b mar10t textCenter primary-color">
          آخرین امتیازات دریافت و پرداخت شده
        </h3>
        <div class="btn-green dFlex mar10b space-between" v-for="item in scoreItem" v-bind:key="item.id"
          :class="item.title == 'خرید کد تخفیف' ? 'red-bg' : ''">
          <p>{{ item.title }}</p>
          <p>
            {{ item.score | persian }}
            <i class="fa fa-minus" v-if="item.title == 'خرید کد تخفیف'"></i>
            <i v-else class="fa fa-plus"></i>
          </p>
        </div>
        <div class="input primary-btn" @click="showModal">مشاهده جزئیات</div>
      </div>
      <div class="error-message textCenter" v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <div class="success-message textCenter" v-if="successMessage">
        {{ successMessage }}
      </div>

      <MainModal v-if="isModalVisible" @close="closeModal" class="pad0">
        <template v-slot:header>
          <h4 class="textCenter primary-color mar10b">جزئیات امتیازات</h4>
          <i class="fa fa-times" @click="closeModal()"></i>
        </template>
        <template v-slot:body>
          <div>
            <div class="score-box">
              <div>تاریخ</div>
              <div>هزینه</div>
              <div>امتیاز</div>
            </div>
            <div v-for="item in scoreDetail" v-bind:key="item.id">
              <div class="input score-box" ref="color" style="position: relative;"
                :class="item.score < 0 ? 'red' : 'green'">
                <div class="pad10l">{{ item.persianDate | persian }}</div>
                <div>
                  <div v-if="item.title_Bonus">{{ item.title_Bonus }}</div>
                  <div v-else>-</div>
                </div>
                <div class="scores pad15r" :class="item.score < 0 ? 'ltr letter-space2' : 'rtl'">
                  {{ item.score | persian }}
                  <i class="fa fa-plus" v-if="item.score > 0"></i>
                </div>
                <img class="semicircular" src="../../assets/img/semi-circle.svg" alt="semi-circle" />
                <!-- <div class="semicircular primary-color">⯋</div> -->
              </div>
              <div class="textCenter">{{ item.description }}</div>
            </div>
          </div>
        </template>
      </MainModal>
    </div>
  </div>
</template>
<script>
import ClubHeader from '../../components/Club/Header.vue'
import MainModal from '../../components/MainModal.vue'
import api from '../../service'
import ClubFooter from '../../components/Club/ClubFooter.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      Items: [],
      isModalVisible: false,
      errorMessage: null,
      successMessage: null,
      scoreItem: [],
      infoItems: [],
      scoreDetail: [],
    }
  },
  components: {
    MainModal,
    ClubHeader,
    ClubFooter,
  },
  computed: {
    ...mapGetters(['getToken']),
  },
  methods: {
    ...mapActions(['setTheme', 'setToken']),
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
  },
  mounted: function () {
    if (this.$route.query.token) {
      console.log(this.$route.query.token)
      this.setToken(this.$route.query.token)
    }
    if (this.$route.query.token) {
      this.$ga.event('club', 'clicked', 'تاریخچه')
      api
        .getInfoUserBonus()
        .then((response) => {
          // console.log(response);
          debugger
          if (response.data && response.status === 200) {
            this.scoreItem = response.data.data.scores
            this.infoItems = response.data.data.info
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0]
            }
          }
        })
        .catch(() => {
          this.errorMessage = 'متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.'
        })
        .finally(() => {
          this.loading = false
        })
      api
        .getBonusDetails({
          PageNo: 1,
          PageSize: 50,
          Type: 5,
        })
        .then((response) => {
          // console.log(response);
          //debugger
          if (response.data && response.status === 200) {
            this.scoreDetail = response.data.data.details
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0]
            }
          }
        })
        .catch((e) => {
          console.log(e.response)
          this.errorMessage = 'متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.'
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>
<style scoped>
.modal-backdrop {
  align-items: unset !important;
}

.modal-backdrop .modal {
  margin: 40px 10px !important;
}

.semicircular {
  width: 10px;
  position: absolute;
  left: calc(50% - 5px);
  bottom: -10px;
}

.score-box {
  display: flex;
}

.score-box>div:not(.semicircular) {
  width: calc(100% / 3);
  text-align: center;
}

.red {
  color: #c62127;
}

.green {
  color: green;
}

i {
  font-size: 7px;
  margin-right: -2px;
}

.club-box>.custom-box:first-child {
  background: #fff;
  border-bottom: 10px solid #002664;
  margin: -50px 0 20px;
}

.club-box>.custom-box:first-child img {
  width: 50px;
}

.custom-box {
  margin-right: 0;
  margin-left: 0;
}

.letter-space2 {
  letter-spacing: 2px;
}

h3 {
  font-weight: normal;
}

.fa-times {
  font-size: 14px;
  position: absolute;
  top: 13px;
  left: 0;
  background: #fff;
  color: #f02229;
  box-shadow: 0 0 1px 2px #f2f2f2;
  padding: 5px 7px;
  border-radius: 50%;
}
</style>
